module.exports = __webpack_public_path__ + "static/media/Wella_White.bfbec7d3.png";